/**
 * Scale Labs — CRO do tema Broadcast (Avelyn Jewelry)
 *
 * Sticky add-to-cart: o Broadcast só põe um ADD TO CART real na barra quando o
 * produto não tem opção nenhuma (`has_only_default_variant`). Nesta loja isso
 * quase nunca acontece — 625 dos 815 produtos têm várias variantes, e mesmo os
 * de variante única têm opção com nome. Resultado: a barra mostrava
 * "CONFIGURE" e limitava-se a fazer scroll.
 *
 * Estratégia: em vez de duplicar a lógica do formulário (variantes, validação,
 * estado de loading, abertura do drawer), a barra passa a **carregar no botão
 * real** do tema. Herda tudo, incluindo o que as apps lhe pendurarem.
 */
(function () {
  'use strict';

  var SEL_BOTAO_REAL = '.product__submit__add[data-add-to-cart], [data-add-to-cart]';

  function botaoReal() {
    // O da barra também tem data-add-to-cart-bar — nunca o queremos aqui
    var todos = document.querySelectorAll(SEL_BOTAO_REAL);
    for (var i = 0; i < todos.length; i++) {
      if (!todos[i].closest('#cart-bar')) return todos[i];
    }
    return null;
  }

  function arrancar() {
    var barra = document.querySelector('#cart-bar');
    if (!barra) return;

    var btnBarra = barra.querySelector('button');
    var btnReal = botaoReal();
    if (!btnBarra || !btnReal) return;

    // ------------------------------------------------ botão: proxy do real
    if (btnBarra.hasAttribute('data-cart-bar-scroll')) {
      btnBarra.removeAttribute('data-cart-bar-scroll');
      btnBarra.setAttribute('data-scale-atc-proxy', '');

      btnBarra.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var alvo = botaoReal();
        if (!alvo || alvo.disabled) return;
        alvo.click();
      });
    }

    // ------------------------------------------- espelhar texto e estado
    // Espelhar em vez de reformatar: o texto e o preço acompanham sozinhos a
    // troca de variante, os descontos e a moeda do mercado.
    var textoBarra = btnBarra.querySelector('.btn__text');

    function sincronizar() {
      var alvo = botaoReal();
      if (!alvo) return;
      var t = (alvo.querySelector('.btn__text') || alvo).textContent.trim();
      if (textoBarra && t && textoBarra.textContent.trim() !== t) textoBarra.textContent = t;
      if (alvo.disabled !== btnBarra.disabled) btnBarra.disabled = alvo.disabled;
    }

    sincronizar();
    document.addEventListener('theme:variant:change', function () { setTimeout(sincronizar, 30); });
    new MutationObserver(sincronizar).observe(btnReal, {
      attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'class']
    });

    // A miniatura é renderizada pelo Liquid (snippets/cart-bar.liquid) — as
    // imagens do tema são lazy e no arranque ainda não têm currentSrc.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();

/**
 * Scale Labs — 28/08
 *
 * 1) Travão de eixo na galeria do produto (mobile)
 * 2) Swatches: no máximo 3 bolinhas, nunca duas da mesma cor
 */
(function () {
  'use strict';

  // Marca de versão — serve para confirmar num instante, na consola da loja,
  // qual a revisão do CRO que está mesmo a correr (`window.scaleCRO`).
  window.scaleCRO = { versao: '2026-08-28', arrancou: false };

  /* ====================================================== 1. travão de eixo

     No telemóvel a galeria da PDP é um *fader*: o tema ouve touchstart/
     touchmove/touchend em modo `passive` e só troca a imagem no fim do gesto.
     Como nunca chama preventDefault, um arrasto lateral ligeiramente
     inclinado faz a PÁGINA subir e descer ao mesmo tempo — a sensação de que
     a imagem "foge" para baixo enquanto se tenta passar à seguinte.

     Aqui decide-se o eixo nos primeiros 8 px do gesto: se for horizontal,
     bloqueia-se o scroll vertical até ao touchend. Se for vertical, não se
     toca em nada e a página desliza como sempre.

     Guarda importante: onde a galeria é um carrossel de scroll NATIVO
     (`product__images--mobile-slider`), o browser já trava o eixo sozinho e
     um preventDefault aqui partia o scroll-snap. Por isso o lock só entra
     quando o elemento não tem scroll horizontal próprio.
     ------------------------------------------------------------------- */

  var LIMIAR_PX = 8;

  function travarEixo(lista) {
    if (lista.hasAttribute('data-scale-axis-lock')) return;
    lista.setAttribute('data-scale-axis-lock', '');

    var x0 = 0;
    var y0 = 0;
    var eixo = null; // null = ainda a decidir | 'x' | 'y' | 'livre'

    lista.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { eixo = 'livre'; return; } // pinch-zoom
      eixo = null;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });

    lista.addEventListener('touchmove', function (e) {
      if (eixo === 'livre' || eixo === 'y') return;
      if (e.touches.length !== 1) { eixo = 'livre'; return; }

      var dx = e.touches[0].clientX - x0;
      var dy = e.touches[0].clientY - y0;

      if (eixo === null) {
        if (Math.abs(dx) < LIMIAR_PX && Math.abs(dy) < LIMIAR_PX) return;
        if (lista.scrollWidth > lista.clientWidth + 1) { eixo = 'livre'; return; }
        eixo = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }

      if (eixo === 'x' && e.cancelable) e.preventDefault();
    }, { passive: false });

    ['touchend', 'touchcancel'].forEach(function (ev) {
      lista.addEventListener(ev, function () { eixo = null; }, { passive: true });
    });
  }

  function travarGalerias() {
    document.querySelectorAll('[data-product-media-list]').forEach(travarEixo);
  }

  /* ============================================ 2. swatches sem repetições

     O tema mostra 5 bolinhas e um "+N". Com 63 valores de cor no catálogo —
     "Gold", "18k Gold Plated", "18k Gold Over Sterling Silver", "925 Sterling
     Silver" — davam duas bolinhas douradas iguais seguidas de duas prateadas
     iguais. Uma bolinha repetida não informa nada e faz o cartão parecer
     partido.

     Regra: 3 bolinhas no máximo, e nunca duas com o mesmo aspeto. A cor lida
     é a que o browser realmente pinta (inclui os gradientes de dois materiais
     definidos em scale-cro.css), por isso "ouro sobre prata" conta como
     distinta de "ouro" e de "prata". O "+N" passa a contar tudo o que ficou
     de fora, escondido por limite ou por repetição.
     ------------------------------------------------------------------- */

  var MAX_BOLINHAS = 3;

  function aspetoDo(botao) {
    var alvo = botao.querySelector('[data-swatch-link]') || botao;
    var cs = window.getComputedStyle(alvo);
    var img = cs.backgroundImage;
    return img && img !== 'none' ? img : cs.backgroundColor;
  }

  function arrumarSwatches(gs) {
    var botoes = gs.querySelectorAll('[data-swatch-button]');
    if (!botoes.length) return;

    var contador = gs.querySelector('.swatch-limited');

    // O total de cores do produto fixa-se na PRIMEIRA passagem: as bolinhas
    // que o tema desenhou mais o "+N" que ele próprio escreveu. Daí para a
    // frente lê-se do dataset — voltar a somar o "+N" a cada passagem fazia o
    // número subir sozinho (um produto de 4 cores chegou a mostrar "+10").
    var total = parseInt(gs.getAttribute('data-scale-total'), 10);

    if (!total) {
      var jaDeFora = contador ? parseInt(contador.textContent.replace(/\D/g, ''), 10) || 0 : 0;
      total = botoes.length + jaDeFora;
      gs.setAttribute('data-scale-total', total);
    }

    var vistos = Object.create(null);
    var mostrados = 0;

    botoes.forEach(function (botao) {
      var aspeto = aspetoDo(botao);
      var repetido = aspeto in vistos;

      if (!repetido && mostrados < MAX_BOLINHAS) {
        vistos[aspeto] = true;
        mostrados++;
        botao.style.removeProperty('display');
      } else {
        botao.style.display = 'none';
      }
    });

    var deFora = total - mostrados;

    if (deFora > 0) {
      if (!contador) {
        contador = document.createElement('div');
        contador.className = 'swatch-limited';
        gs.appendChild(contador);
      }
      contador.textContent = '+' + deFora;
    } else if (contador) {
      contador.remove();
    }

    gs.setAttribute('data-scale-trimmed', '');
  }

  /* Os grid-swatch renderizam-se sozinhos depois de um fetch ao produto, e
     voltam a aparecer no "load more" e nos separadores diferidos da home —
     daí o observador em vez de uma passagem única. */
  var pendentes = new Set();
  var agendado = false;
  var observador = null;

  function agendar(gs) {
    pendentes.add(gs);
    if (agendado) return;
    agendado = true;
    // setTimeout e não requestAnimationFrame: o Chrome não corre rAF em
    // separadores que não estão à frente, e um separador de fundo ficava com
    // as bolinhas por arrumar até alguém lhe pegar.
    setTimeout(function () {
      agendado = false;
      var lote = [...pendentes];
      pendentes.clear();
      lote.forEach(arrumarSwatches);
      // Descarta as mutações que a própria arrumação acabou de provocar
      // (escrever o "+N"), senão o observador chamava-se a si mesmo em ciclo.
      if (observador) observador.takeRecords();
    }, 16);
  }

  function observar() {
    observador = new MutationObserver(function (mutacoes) {
      mutacoes.forEach(function (m) {
        var gs = m.target.closest ? m.target.closest('grid-swatch') : null;
        if (gs) { agendar(gs); return; }

        m.addedNodes.forEach(function (no) {
          if (no.nodeType !== 1) return;
          if (no.tagName === 'GRID-SWATCH') agendar(no);
          else no.querySelectorAll?.('grid-swatch').forEach(agendar);
        });
      });
    });

    observador.observe(document.body, { childList: true, subtree: true });

    document.querySelectorAll('grid-swatch').forEach(agendar);
  }

  function arrancar28() {
    travarGalerias();
    observar();
    document.addEventListener('shopify:section:load', travarGalerias);
    window.scaleCRO.arrancou = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar28);
  } else {
    arrancar28();
  }
})();

/**
 * Scale Labs — 28/08: add-on do carrinho (01/09: passou a ser o kit de limpeza)
 *
 * O visto liga e desliga uma linha do carrinho. Não se usa `data-add-to-cart`
 * neste botão de propósito: esse atributo é o que a barra sticky da PDP procura
 * para saber qual é o botão real de compra, e o drawer existe em todas as
 * páginas — herdá-lo aqui punha a barra a vender o add-on em vez da peça.
 *
 * Delegação no documento porque o carrinho é substituído por inteiro a cada
 * atualização; listeners presos ao nó morrem com ele.
 */
(function () {
  'use strict';

  var HANDLE = 'silver-polishing-cloth-bundle';

  function bloco(el) {
    return el.closest('[data-scale-protection]');
  }

  /**
   * Põe o bloco de acordo com o carrinho que está no DOM:
   *   - esconde-o enquanto não houver nenhuma PEÇA no carrinho (só o add-on
   *     sozinho não é carrinho nenhum);
   *   - marca ou desmarca o visto conforme o add-on lá esteja;
   *   - guarda a chave da linha, que é o que permite removê-lo depois.
   * Corre a cada `theme:cart:change` — o evento que o tema dispara sempre que
   * o carrinho é reconstruído.
   */
  function sincronizar() {
    var raiz = document.querySelector('[data-scale-protection]');
    if (!raiz) return;

    var linhas = document.querySelectorAll('.cart__item[data-item-handle]');
    var linhaAddon = null;
    var pecas = 0;

    linhas.forEach(function (linha) {
      if (linha.getAttribute('data-item-handle') === HANDLE) linhaAddon = linha;
      else pecas++;
    });

    raiz.hidden = pecas === 0;
    raiz.classList.toggle('scale-protect--on', !!linhaAddon);
    raiz.classList.remove('scale-protect--busy');

    if (linhaAddon) raiz.setAttribute('data-line-key', linhaAddon.getAttribute('data-item'));
    else raiz.removeAttribute('data-line-key');

    var caixa = raiz.querySelector('[data-scale-protection-toggle]');
    if (caixa) caixa.checked = !!linhaAddon;
  }

  function terminar(caixa, ok) {
    var raiz = bloco(caixa);
    if (raiz) raiz.classList.remove('scale-protect--busy');
    if (!ok) caixa.checked = !caixa.checked; // repõe o visto se falhou
  }

  function refrescarCarrinho() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    // rede de segurança: se por alguma razão o `theme:cart:change` não vier,
    // o bloco não fica preso em "a carregar".
    setTimeout(sincronizar, 1200);
  }

  function adicionar(caixa, raiz) {
    var id = raiz.getAttribute('data-variant-id');
    if (!id) return terminar(caixa, false);

    fetch(window.theme?.routes?.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (r) { return r.json(); })
      .then(function (resposta) {
        if (resposta && resposta.status) return terminar(caixa, false);
        refrescarCarrinho();
      })
      .catch(function () { terminar(caixa, false); });
  }

  function remover(caixa, raiz) {
    // A linha do add-on pode já ter sido removida à mão na lista do carrinho
    var linha = document.querySelector('.cart__item[data-item-handle="' + HANDLE + '"]');
    var chave = raiz.getAttribute('data-line-key');
    if (!chave && !linha) return terminar(caixa, true);

    fetch(window.theme?.routes?.cart_change_url || '/cart/change', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: chave || linha.getAttribute('data-item'), quantity: 0 }),
    })
      .then(function (r) { return r.json(); })
      .then(function () { refrescarCarrinho(); })
      .catch(function () { terminar(caixa, false); });
  }

  document.addEventListener('theme:cart:change', sincronizar);
  document.addEventListener('theme:cart-drawer:open', sincronizar);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sincronizar);
  } else {
    sincronizar();
  }

  document.addEventListener('change', function (e) {
    var caixa = e.target.closest ? e.target.closest('[data-scale-protection-toggle]') : null;
    if (!caixa) return;

    var raiz = bloco(caixa);
    if (!raiz || raiz.classList.contains('scale-protect--busy')) return;

    raiz.classList.add('scale-protect--busy');
    caixa.checked ? adicionar(caixa, raiz) : remover(caixa, raiz);
  });
})();

/**
 * Scale Labs — 31/08: barra de urgência do carrinho
 *
 * O prazo vive em `sessionStorage`, não em `localStorage`: conta para baixo
 * enquanto o cliente navega, mas não o persegue entre visitas — um contador que
 * reaparece a 09:59 três dias depois só ensina o cliente a não acreditar nele.
 *
 * O rodapé do drawer NÃO é redesenhado no AJAX do carrinho (ver o comentário em
 * `snippets/scale-protection.liquid`), por isso um contador preso ao nó
 * sobreviveria — mas na página /cart o nó é outro, e nas páginas seguintes é
 * outro ainda. Daí o prazo estar na sessão e não na variável.
 *
 * Só aparece quando há PEÇAS no carrinho — a mesma regra do add-on: o add-on
 * sozinho não é carrinho nenhum.
 */
(function () {
  'use strict';

  var CHAVE = 'scale_cart_deadline';
  var HANDLE_ADDON = 'silver-polishing-cloth-bundle';
  var relogio = null;

  function nos() {
    return document.querySelectorAll('[data-scale-urgency]');
  }

  function temPecas() {
    var linhas = document.querySelectorAll('.cart__item[data-item-handle]');
    for (var i = 0; i < linhas.length; i++) {
      if (linhas[i].getAttribute('data-item-handle') !== HANDLE_ADDON) return true;
    }
    return false;
  }

  /** Prazo da sessão. Cria-o à primeira peça; nunca o estica depois disso. */
  function prazo(minutos) {
    minutos = minutos || 10;
    var guardado = null;
    try { guardado = sessionStorage.getItem(CHAVE); } catch (e) { /* modo privado */ }

    var t = guardado ? parseInt(guardado, 10) : NaN;
    if (!t || isNaN(t)) {
      t = Date.now() + minutos * 60000;
      try { sessionStorage.setItem(CHAVE, String(t)); } catch (e) { /* idem */ }
    }
    return t;
  }

  function mmss(ms) {
    var s = Math.max(0, Math.round(ms / 1000));
    var m = Math.floor(s / 60);
    // Minutos com zero à esquerda: "09:07" e "10:00" ocupam o mesmo espaço.
    return ('0' + m).slice(-2) + ':' + ('0' + (s % 60)).slice(-2);
  }

  function pintar() {
    var lista = nos();
    if (!lista.length) return parar();

    var visivel = temPecas();
    var agora = Date.now();

    lista.forEach(function (no) {
      no.hidden = !visivel;
      if (!visivel) return;

      var minutos = parseInt(no.getAttribute('data-minutes'), 10) || 10;
      var falta = prazo(minutos) - agora;

      var titulo = no.querySelector('[data-scale-urgency-title]');
      var nota = no.querySelector('[data-scale-urgency-note]');
      var clock = no.querySelector('[data-scale-urgency-clock]');

      if (falta > 0) {
        if (clock) clock.textContent = mmss(falta);
        no.classList.toggle('scale-urgency--warn', falta <= 60000);
        return;
      }

      // Esgotado: sem relógio e sem promessa nenhuma sobre stock.
      no.classList.remove('scale-urgency--warn');
      no.classList.add('scale-urgency--expired');
      if (titulo) titulo.textContent = 'Your cart is no longer being held';
      if (nota) nota.innerHTML = 'Check out to secure <strong>Buy 2, Get 2 Free</strong> before it changes.';
    });

    if (visivel && prazo() - agora <= 0) parar();
  }

  function arrancar() {
    pintar();
    if (relogio || !nos().length) return;
    relogio = setInterval(pintar, 1000);
  }

  function parar() {
    if (relogio) { clearInterval(relogio); relogio = null; }
  }

  document.addEventListener('theme:cart:change', pintar);
  document.addEventListener('theme:cart-drawer:open', arrancar);
  // A aba em segundo plano não recebe setInterval de segundo a segundo no
  // Chrome; ao voltar, o relógio tem de saltar para as horas certas.
  document.addEventListener('visibilitychange', function () { if (!document.hidden) pintar(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();

/**
 * Scale Labs — 03/09: matar o "pop-in" das linhas de produtos.
 *
 * O sintoma (o "os produtos estão a dançar"): ao fazer scroll, cada linha
 * chega como caixas bege vazias e só depois é que as fotografias e os selos
 * SALE aparecem. Medido a 390x844: ao saltar para uma zona nova da homepage,
 * **2,2% do ecrã muda nos primeiros 250 ms e mais 1,2% até aos ~850 ms**; a
 * partir daí fica quieto (0%). Nenhum teste de posição, de hover ou de CLS
 * apanha isto — não há movimento nenhum, o que muda é o CONTEÚDO das caixas.
 *
 * A causa é o `loading="lazy"` nativo: o Chrome só começa a pedir a imagem
 * quase à porta do ecrã. É o preço do trabalho de peso de 30/08, e não se quer
 * desfazer esse trabalho — o que se quer é pedir as imagens MAIS CEDO, sem
 * lhes tocar no carregamento inicial da página.
 *
 * O que isto faz: observa as imagens `lazy` com uma margem de ~2,5 ecrãs e,
 * quando entram nessa margem, aquece-as — um pedido paralelo que fica na cache
 * HTTP. O `<img>` real não é tocado (ver a nota em `aquecer`). Quando a linha
 * chega ao ecrã, o ficheiro já está em cache e a foto aparece de imediato.
 *
 * Cuidados:
 *   - Só arranca no `requestIdleCallback` (com rede de segurança de 1,5 s):
 *     não rouba largura de banda ao primeiro ecrã nem ao LCP.
 *   - O MutationObserver apanha as grelhas que chegam depois (filtros,
 *     paginação, o drawer do carrinho).
 *   - `WeakSet` para não aquecer a mesma imagem duas vezes.
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var MARGEM = '2200px 0px';
  var aquecidas = new WeakSet();

  function aquecer(img) {
    if (aquecidas.has(img)) return;
    aquecidas.add(img);

    // Pedido paralelo: entra na cache HTTP com o mesmo srcset/sizes, por isso
    // o browser reaproveita-o quando o <img> real decidir carregar.
    var pre = new Image();
    if (img.sizes) pre.sizes = img.sizes;
    if (img.srcset) pre.srcset = img.srcset;
    if (img.src) pre.src = img.src;

    /* NÃO se mexe no atributo `loading` do <img> real.
       Tentou-se `img.loading = 'eager'` e as fotografias dos cartões ficaram
       em branco: o tema desenha a imagem dentro de um `.lazy-image` e tem a
       sua própria máquina de estados (`is-loading`, opacidade, `lli()`).
       Passar o <img> a eager por baixo dela deixa-a a meio. O aquecimento em
       paralelo chega — quando o <img> carregar, o ficheiro já está em cache e
       a máquina do tema corre como sempre. */
  }

  var observador = new IntersectionObserver(function (entradas) {
    for (var i = 0; i < entradas.length; i++) {
      if (!entradas[i].isIntersecting) continue;
      aquecer(entradas[i].target);
      observador.unobserve(entradas[i].target);
    }
  }, { rootMargin: MARGEM });

  function ligar(raiz) {
    var imgs = (raiz || document).querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      if (!aquecidas.has(imgs[i])) observador.observe(imgs[i]);
    }
  }

  function arrancar() {
    ligar(document);

    new MutationObserver(function (mutacoes) {
      for (var i = 0; i < mutacoes.length; i++) {
        var novos = mutacoes[i].addedNodes;
        for (var j = 0; j < novos.length; j++) {
          var no = novos[j];
          if (no.nodeType !== 1) continue;
          if (no.tagName === 'IMG') {
            if (no.loading === 'lazy' && !aquecidas.has(no)) observador.observe(no);
          } else {
            ligar(no);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function agendar() {
    if (window.requestIdleCallback) requestIdleCallback(arrancar, { timeout: 1500 });
    else setTimeout(arrancar, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agendar);
  } else {
    agendar();
  }
})();

/**
 * Scale Labs — 03/09: campo de escrita das peças personalizadas.
 *
 * O HTML vem de `snippets/scale-personalizacao.liquid`. Aqui decide-se **quando**
 * aparece, **quantos** campos, e **impede-se** o add-to-cart sem texto.
 *
 * Como se sabe o que está escolhido: lê-se o `input[name="id"]` do formulário
 * (é ele que vai para o carrinho), procura-se essa variante no
 * `<script data-product-json>` e comparam-se os `options` dela com os nomes das
 * opções do produto. Não se depende do payload de nenhum evento do tema — só do
 * que vai mesmo ser submetido.
 *
 * Regra dos `disabled`: um campo escondido mas ativo **continua a ser
 * submetido**. Os campos que não estão em uso ficam `disabled`, e os `disabled`
 * não entram no `FormData`. É isso que impede lixo nas encomendas.
 */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-scale-perso]');
  if (!raiz) return;

  var noJson = document.querySelector('[data-product-json]');
  if (!noJson) return;

  var produto;
  try {
    produto = JSON.parse(noJson.textContent);
  } catch (e) {
    return;
  }
  if (!produto || !produto.variants) return;

  var campos = [].slice.call(raiz.querySelectorAll('[data-scale-perso-campo]'));
  var erro = raiz.querySelector('[data-scale-perso-erro]');
  var nomeSimNao = raiz.getAttribute('data-opcao-sim-nao') || '';
  var nomeContagem = raiz.getAttribute('data-opcao-contagem') || '';
  var limite = parseInt(raiz.getAttribute('data-limite'), 10) || 20;

  // Nomes das opções pela ordem em que aparecem no `variant.options`
  var nomesOpcoes = (produto.options || []).map(function (o) {
    return typeof o === 'string' ? o : o.name;
  });

  function varianteAtual() {
    var campoId = document.querySelector('input[name="id"]:not([disabled])');
    var id = campoId ? parseInt(campoId.value, 10) : 0;
    for (var i = 0; i < produto.variants.length; i++) {
      if (produto.variants[i].id === id) return produto.variants[i];
    }
    return null;
  }

  function valorDaOpcao(variante, nome) {
    if (!variante || !nome) return '';
    var i = nomesOpcoes.indexOf(nome);
    if (i < 0) return '';
    return (variante.options && variante.options[i]) || '';
  }

  /* Quantos campos é que esta variante precisa:
       · opção do tipo "Personalized" → 1 quando o valor não é "Standard"/"None"
       · opção de contagem ("Names: 3", "Engravings: 2 Names") → esse número */
  function quantosCampos() {
    var v = varianteAtual();
    if (!v) return 0;

    if (nomeContagem) {
      var bruto = valorDaOpcao(v, nomeContagem);
      var n = parseInt(String(bruto).split(' ')[0], 10);
      return isNaN(n) ? 0 : Math.min(n, campos.length);
    }

    if (nomeSimNao) {
      var valor = String(valorDaOpcao(v, nomeSimNao)).toLowerCase();
      if (!valor || valor === 'standard' || valor === 'none' || valor === 'no') return 0;
      return 1;
    }

    return 0;
  }

  function sincronizar() {
    var n = quantosCampos();

    campos.forEach(function (campo, i) {
      var ativo = i < n;
      campo.hidden = !ativo;

      var input = campo.querySelector('[data-scale-perso-input]');
      if (!input) return;

      // `disabled` é o que decide se vai para o carrinho — não é só estética.
      input.disabled = !ativo;
      if (!ativo) input.value = '';
      atualizarContador(input);
    });

    raiz.hidden = n === 0;
    if (n === 0) esconderErro();
  }

  function atualizarContador(input) {
    var contador = input.parentElement.querySelector('[data-scale-perso-contador]');
    if (contador) contador.textContent = input.value.length + '/' + limite;
  }

  function esconderErro() {
    if (erro) erro.hidden = true;
    raiz.classList.remove('scale-perso--erro');
  }

  function porPreencher() {
    return campos.some(function (campo) {
      if (campo.hidden) return false;
      var input = campo.querySelector('[data-scale-perso-input]');
      return input && !input.disabled && input.value.trim() === '';
    });
  }

  raiz.addEventListener('input', function (e) {
    var input = e.target.closest ? e.target.closest('[data-scale-perso-input]') : null;
    if (!input) return;
    atualizarContador(input);
    if (input.value.trim() !== '') esconderErro();
  });

  /* Travão do add-to-cart.
     Na fase de CAPTURA e no documento: apanha o botão real, o botão da barra
     fixa (que faz `.click()` no real) e qualquer app que carregue no mesmo
     botão. Sem isto, o pedido saía com a propriedade vazia. */
  document.addEventListener('click', function (e) {
    var botao = e.target.closest ? e.target.closest('[data-add-to-cart]') : null;
    if (!botao || botao.closest('.product-upsell')) return;
    if (raiz.hidden || !porPreencher()) return;

    e.preventDefault();
    e.stopPropagation();

    if (erro) erro.hidden = false;
    raiz.classList.add('scale-perso--erro');

    var primeiro = campos.filter(function (c) {
      if (c.hidden) return false;
      var i = c.querySelector('[data-scale-perso-input]');
      return i && i.value.trim() === '';
    })[0];

    if (primeiro) {
      var input = primeiro.querySelector('[data-scale-perso-input]');
      raiz.scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (input) input.focus({ preventScroll: true });
    }
  }, true);

  // O tema troca a variante por vários caminhos — ouvem-se todos.
  document.addEventListener('change', function () { setTimeout(sincronizar, 30); });
  document.addEventListener('theme:variant:change', function () { setTimeout(sincronizar, 30); });

  var campoId = document.querySelector('input[name="id"]');
  if (campoId) {
    new MutationObserver(sincronizar).observe(campoId, { attributes: true, attributeFilter: ['value'] });
  }

  sincronizar();
})();

/* Scale Labs — 03/09 (revisto às 22h): o bloco que fazia scroll até à foto da
   variante foi RETIRADO.

   Porquê: resolvia o sintoma pelo lado errado. Com a galeria "stacked" (todas as
   fotos empilhadas), trocar de cor obrigava a página a saltar ~1338 px até à foto
   certa — e para quem estava a olhar para o topo, a leitura era "a imagem não
   mudou, a página fugiu". A correção verdadeira é a galeria passar a
   `thumbnails`: uma imagem grande que TROCA no sítio, como já acontecia no
   telemóvel e no quick-add. Está em `image_layout` nos dois templates. */

/**
 * Scale Labs — 03/09: a pesquisa preditiva estava a desenhar-se FORA do ecrã.
 *
 * Sintoma (pasta 20 do Álvaro): escreve-se na pesquisa e aparece uma área
 * branca enorme com um link solto e o botão "SEARCH FOR …" — o resto não se vê.
 *
 * O que se mede: o painel `.predictive-search` tem `position: absolute` e
 * `top: 80px`, mas o retângulo real dá **top: -324px**. Ou seja, o bloco que
 * lhe serve de referência está ~404 px acima do ecrã (o `<header>` é
 * `position: absolute` e mexe-se com o comportamento sticky), e o painel vai
 * atrás dele. Os resultados existem — 461 px de altura, cheios de sugestões e
 * produtos — só que desenhados por cima do topo da janela.
 *
 * Correção: o painel passa a `position: fixed` e o `top` é calculado a partir
 * da barra de pesquisa que se vê, não de um contentor que anda a passear.
 * Recalcula-se no scroll e no resize, porque o header encolhe ao descer.
 */
(function () {
  'use strict';

  var SELETOR = '.predictive-search';

  function barraVisivel(painel) {
    var pop = painel.closest('.search-popdown') || painel.closest('header-search-popdown');
    if (!pop) return null;
    var barra = pop.querySelector('.search-popdown__main') || pop;
    return barra;
  }

  function posicionar(painel) {
    var barra = barraVisivel(painel);
    if (!barra) return;

    var r = barra.getBoundingClientRect();
    if (r.height === 0) return;

    var desejado = Math.max(0, Math.round(r.bottom));

    painel.style.position = 'fixed';
    painel.style.left = '0';
    painel.style.right = '0';
    painel.style.width = '100vw';
    painel.style.top = desejado + 'px';
    painel.style.maxHeight = 'calc(100vh - ' + desejado + 'px)';
    painel.style.overflowY = 'auto';

    /* O `<header>` tem um `transform` (identidade, posto pelo AOS) e **um
       transform, mesmo identidade, faz o `position: fixed` passar a resolver
       contra esse elemento em vez da janela**. É a armadilha que fazia o painel
       aparecer a -324 px do topo.

       Em vez de andar a caçar quem tem transform, mede-se o erro e corrige-se:
       põe-se o `top` desejado, lê-se onde o painel ficou mesmo, e desconta-se a
       diferença. Funciona seja qual for o contentor. */
    var erro = painel.getBoundingClientRect().top - desejado;
    if (Math.abs(erro) > 1) painel.style.top = (desejado - erro) + 'px';
  }

  function visivel(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function repor() {
    var paineis = document.querySelectorAll(SELETOR);
    for (var i = 0; i < paineis.length; i++) {
      if (visivel(paineis[i])) posicionar(paineis[i]);
    }
  }

  /* ⚠️ O observer NÃO pode ouvir `style`: o `posicionar()` escreve `style.top`,
     isso dispara o observer, que chama `posicionar()` outra vez — ciclo
     infinito que pendura a página (apanhado em teste, o Chrome deixou de
     responder). Ouve-se `class` e `open`, que é o que o tema mexe ao abrir a
     pesquisa, e trava-se com um requestAnimationFrame para não reentrar. */
  var agendado = false;
  function reporEmBreve() {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(function () {
      agendado = false;
      repor();
    });
  }

  new MutationObserver(reporEmBreve).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'open']
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'q') setTimeout(repor, 60);
  });

  window.addEventListener('scroll', reporEmBreve, { passive: true });
  window.addEventListener('resize', reporEmBreve);
})();

/**
 * Scale Labs — 03/09: depoimentos a andar sozinhos (pasta 16).
 *
 * A secção é a `section-reviews` (no template do cobre), e por baixo é um
 * `<grid-slider>` com scroll nativo — `.reviews__grid.grid--slider`. Não é
 * flickity, portanto não há opção de autoplay para ligar: faz-se aqui.
 *
 * Regras de bom senso, para não ser um carrossel irritante:
 *   · pára quando o rato está por cima, quando alguém lhe toca, ou quando um
 *     elemento lá dentro ganha foco (teclado);
 *   · pára durante 12 s depois de a pessoa arrastar à mão — quem está a ler não
 *     quer a página a fugir-lhe;
 *   · não anda quando a secção não está no ecrã (IntersectionObserver);
 *   · respeita `prefers-reduced-motion`.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var INTERVALO = 5000;
  var PAUSA_APOS_TOQUE = 12000;

  var grelhas = document.querySelectorAll('.reviews__grid');
  if (!grelhas.length) return;

  [].forEach.call(grelhas, function (grelha) {
    if (grelha.scrollWidth <= grelha.clientWidth + 4) return; // nada para andar

    var pausado = false;
    var retomarEm = 0;
    var noEcra = false;

    /* O passo é a distância entre dois cartões, medida no DOM (offsetLeft), e
       não a largura do primeiro filho: nesta secção o primeiro filho ocupava
       dois cartões e o carrossel saltava o último depoimento. */
    function largura() {
      var filhos = grelha.children;
      if (filhos.length > 1) {
        var passo = filhos[1].offsetLeft - filhos[0].offsetLeft;
        if (passo > 20) return Math.round(passo);
      }
      return Math.round(grelha.clientWidth);
    }

    function avancar() {
      if (pausado || !noEcra || Date.now() < retomarEm) return;
      if (grelha.scrollWidth <= grelha.clientWidth + 4) return;

      var passo = largura();
      var fim = grelha.scrollWidth - grelha.clientWidth - 4;
      var destino = grelha.scrollLeft + passo;

      /* Antes voltava ao início assim que o passo seguinte passasse do fim — e
         com 5 depoimentos de 720 px num ecrã de 1440 isso fazia com que o
         **último nunca aparecesse** (0 → 1440 → volta ao 0). Agora encosta ao
         fim primeiro, mostra o que falta, e só depois recomeça. */
      if (grelha.scrollLeft >= fim - 8) destino = 0;
      else if (destino > fim) destino = fim;

      grelha.scrollTo({ left: destino, behavior: 'smooth' });
    }

    ['pointerenter', 'focusin'].forEach(function (evento) {
      grelha.addEventListener(evento, function () { pausado = true; });
    });
    ['pointerleave', 'focusout'].forEach(function (evento) {
      grelha.addEventListener(evento, function () { pausado = false; });
    });

    // Arrastar/rodar à mão adia o próximo avanço.
    ['touchstart', 'wheel'].forEach(function (evento) {
      grelha.addEventListener(evento, function () {
        retomarEm = Date.now() + PAUSA_APOS_TOQUE;
      }, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        noEcra = entradas[0].isIntersecting;
      }, { threshold: 0.35 }).observe(grelha);
    } else {
      noEcra = true;
    }

    setInterval(avancar, INTERVALO);
  });
})();

/**
 * Scale Labs — 03/09: "Complete the set" na lateral, no PC (pastas 22 e 17).
 *
 * O Álvaro: no telemóvel a secção fica bem empilhada; no PC ficava uma faixa de
 * 1440 px a atravessar a página, e o concorrente do cobre põe o upsell numa
 * coluna à direita, ao lado das fotografias.
 *
 * Não se duplica a secção — **move-se**. Duas cópias no DOM dariam dois
 * `quick-add-product` com o mesmo id de produto, e o "Add" passava a ser uma
 * lotaria. Fica um marcador no sítio original para a devolver quando o ecrã
 * encolhe.
 *
 * Vai para logo a seguir ao bloco dos botões: é onde a pessoa acabou de decidir
 * comprar, e é o sítio onde o concorrente a tem.
 */
(function () {
  'use strict';

  var seccao = document.querySelector('.scale-bundle-section');
  var coluna = document.querySelector('.product__content .form__width');
  if (!seccao || !coluna) return;

  var marcador = document.createComment('scale-bundle: sítio original');
  seccao.parentNode.insertBefore(marcador, seccao);

  var ecraGrande = window.matchMedia('(min-width: 990px)');

  function aplicar() {
    if (ecraGrande.matches) {
      if (seccao.parentNode === coluna) return;
      var botoes = coluna.querySelector('.product__block--buttons');
      if (!botoes) return;
      coluna.insertBefore(seccao, botoes.nextSibling);
      seccao.classList.add('scale-bundle-section--lateral');
    } else {
      if (seccao.parentNode !== coluna) return;
      marcador.parentNode.insertBefore(seccao, marcador.nextSibling);
      seccao.classList.remove('scale-bundle-section--lateral');
    }
  }

  aplicar();
  if (ecraGrande.addEventListener) ecraGrande.addEventListener('change', aplicar);
  else ecraGrande.addListener(aplicar);
})();

/**
 * Scale Labs — 04/09: imagens que ficam num pixel transparente.
 *
 * Sintoma: troca-se a cor e a imagem grande fica **em branco**. Medido nos
 * slides escondidos da galeria:
 *
 *   src   = data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAB…   (1x1)
 *   d-src = //avelynjewelry.com/cdn/shop/files/CrossingWaveRing-main-silver.jpg
 *   dt    = (o srcset verdadeiro)
 *   data-li="st"
 *
 * Ou seja: o URL verdadeiro está lá, no `d-src`, à espera de um script que o
 * passe para o `src`. Esse script era da **mesma app de velocidade que já não
 * está na loja** (a do `xsts-loaded`, ver o bloco no layout/theme.liquid). Sem
 * ela, tudo o que não estava visível no primeiro ecrã fica num pixel
 * transparente para sempre.
 *
 * Na galeria da PDP isto é fatal: em modo fader só um slide está visível, e ao
 * trocar de cor mostra-se um slide que nunca chegou a carregar.
 *
 * Aqui faz-se o que a app fazia: `d-src` → `src`, `dt` → `srcset`.
 *   · a galeria do produto é hidratada JÁ (são 5–6 fotos e o cliente vai lá);
 *   · o resto é hidratado à medida que se aproxima do ecrã, para não puxar a
 *     loja inteira de uma vez.
 */
(function () {
  'use strict';

  function hidratar(img) {
    var real = img.getAttribute('d-src');
    if (!real) return;

    var srcset = img.getAttribute('dt');
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', real);

    img.removeAttribute('d-src');
    img.removeAttribute('dt');
    img.removeAttribute('data-li');
    img.classList.remove('is-loading');

    // O tema tira o `is-loading` do <figure> no load da imagem; se a imagem já
    // vier da cache o evento pode não chegar, por isso trata-se aqui também.
    var figura = img.closest('.lazy-image, .image-wrapper');
    if (figura) {
      if (img.complete) figura.classList.remove('is-loading');
      else img.addEventListener('load', function () { figura.classList.remove('is-loading'); }, { once: true });
    }
  }

  function hidratarJa(raiz) {
    var imgs = (raiz || document).querySelectorAll('img[d-src]');
    for (var i = 0; i < imgs.length; i++) hidratar(imgs[i]);
  }

  // 1) Galeria do produto — sem esperar por nada.
  hidratarJa(document.querySelector('product-images') || document.querySelector('.product__slides'));

  // 2) O resto, à medida que se aproxima.
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entradas) {
      for (var i = 0; i < entradas.length; i++) {
        if (!entradas[i].isIntersecting) continue;
        hidratar(entradas[i].target);
        obs.unobserve(entradas[i].target);
      }
    }, { rootMargin: '2200px 0px' });

    var ligar = function (raiz) {
      var imgs = (raiz || document).querySelectorAll('img[d-src]');
      for (var i = 0; i < imgs.length; i++) obs.observe(imgs[i]);
    };

    ligar(document);

    new MutationObserver(function (mutacoes) {
      for (var i = 0; i < mutacoes.length; i++) {
        var novos = mutacoes[i].addedNodes;
        for (var j = 0; j < novos.length; j++) {
          var no = novos[j];
          if (no.nodeType !== 1) continue;
          if (no.tagName === 'IMG' && no.hasAttribute('d-src')) obs.observe(no);
          else ligar(no);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } else {
    hidratarJa(document);
  }
})();

/**
 * Scale Labs — 06/09: a foto da cor escolhida não pode chegar ao topo em branco.
 *
 * Companheiro do CSS `.product__wrapper--stacked .product__slide.media--active
 * { order: -1 }`: em pilha, a foto da variante sobe ao primeiro lugar sem sair
 * do sítio no DOM.
 *
 * O que se mediu e obriga a este bloco: o `order` muda a posição VISUAL e o
 * Chrome **não reavalia o `loading="lazy"`** por causa disso. Sem scroll pelo
 * meio, a foto promovida fica para sempre por carregar:
 *
 *   trocar para Silver → topo = …-main-silver.jpg, complete: false, 0x0
 *   …e 6 segundos depois continua em 0x0.
 *
 * Na carga da página não acontece: aí o primeiro layout já a põe no ecrã.
 * É só na troca de cor, que é exatamente o momento que interessa.
 *
 * ⚠️ A nota do bloco de aquecimento (mais acima) diz para NÃO mexer no
 * `loading` do `<img>` real, e está certa para os cartões: o tema desenha-os
 * dentro de um `.lazy-image` com máquina de estados própria (`is-loading`),
 * e passar a eager por baixo dela deixava-os em branco. Aqui mexe-se em UMA
 * imagem — a da fatia ativa da galeria — e trata-se do `is-loading` a seguir,
 * tal e qual o bloco de hidratação de 04/09 faz. Um aquecimento em paralelo
 * (`new Image()`) não servia: punha o ficheiro em cache mas o `<img>` real
 * continuava sem o pedir.
 *
 * Sem `requestAnimationFrame` de propósito: uma trava com estado é mais uma
 * maneira de isto morrer em silêncio (foi o que aconteceu na 1.ª versão). O
 * trabalho é um `querySelector` e dois atributos — corre à vontade em cada
 * mutação. E o observer ouve só `class`; escreve `loading` e tira `is-loading`,
 * o que o faz correr no máximo mais uma vez, sem ciclo.
 */
(function () {
  'use strict';

  var lista = document.querySelector('[data-product-media-list]');
  if (!lista) return;

  function acordarFatiaAtiva() {
    var ativo = lista.querySelector('.product__slide.media--active');
    if (!ativo) return;

    var imgs = ativo.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.loading !== 'lazy') continue;

      img.loading = 'eager';

      // O tema tira o `is-loading` no load; se a imagem vier da cache o evento
      // pode não chegar, por isso trata-se dos dois casos.
      (function (img) {
        var figura = img.closest('.lazy-image, .image-wrapper');
        if (!figura) return;
        if (img.complete) figura.classList.remove('is-loading');
        else img.addEventListener('load', function () { figura.classList.remove('is-loading'); }, { once: true });
      })(img);
    }
  }

  acordarFatiaAtiva();

  new MutationObserver(acordarFatiaAtiva).observe(lista, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
})();
